import React from 'react';
import { Link } from 'react-router-dom';
import { useScript } from '../context/ScriptContext';
import { useDocumentTitle } from '../hooks/useDocumentTitle';

const CreditsPage: React.FC = () => {
  const { t } = useScript();
  useDocumentTitle(t('Заслуге за фотографије') + ' — ' + t('Манастир Градац'), '/zasluge');

  return (
    <div className="legal-page">
      <div className="legal-page-inner">
        <Link to="/" className="legal-back-link">{t('← Назад')}</Link>
        <h1 className="legal-page-title">{t('Заслуге за фотографије')}</h1>
        <p className="legal-page-updated">{t('Последње ажурирање')}: 07. јул 2026.</p>

        <section className="legal-section">
          <p>
            {t('Овде наводимо ауторе фотографија и визуелних материјала коришћених на овом веб-сајту, у складу са Законом о ауторском и сродним правима Републике Србије.')}
          </p>
        </section>

        <section className="legal-section">
          <h2>{t('Фотографије')}</h2>
          <div className="credits-table">
            <div className="credits-row credits-header">
              <span>{t('Аутор')}</span>
              <span>{t('Садржај')}</span>
              <span>{t('Лиценца')}</span>
            </div>
            <div className="credits-row">
              <span>Светлана Дингарац</span>
              <span>{t('Фотографије манастира, ентеријера и фресака')}</span>
              <span>{t('Сва права задржана')}</span>
            </div>
          </div>
          <p className="credits-note">
            {t('Ова листа ће бити ажурирана како се нове фотографије додају на веб-сајт.')}
          </p>
        </section>

        <section className="legal-section">
          <h2>{t('Контакт за ауторска права')}</h2>
          <p>
            {t('Уколико верујете да је Ваш ауторски рад коришћен на овом веб-сајту без одговарајуће дозволе, молимо Вас да нас контактирате на manastir.gradac@gmail.com.')}
          </p>
        </section>
      </div>
    </div>
  );
};

export default CreditsPage;
